import PrestatorStep from "./steps/PrestatorStep";
import BeneficiarStep from "./steps/BeneficiarStep";
import ServiciiStep from "./steps/ServiciiStep";
import PlataStep from "./steps/PlataStep";
import ClauzeStep from "./steps/ClauzeStep";
import PreviewStep from "./steps/PreviewStep";
import buildPrestariServiciiPDF from "./buildPDF";

const prestariServiciiConfig = {
  buildPDF: buildPrestariServiciiPDF,
  title: "Contract de Prestari Servicii Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un contract de prestari servicii conform Codului Civil",
  step1Benefit: "Clauze clare pentru freelanceri și firme",
  pdfFilename: "contract-prestari-servicii.pdf",
  steps: [
    { id: "prestator", label: "Prestator", title: "Datele Prestatorului", icon: "\u{1F477}", component: PrestatorStep },
    { id: "beneficiar", label: "Beneficiar", title: "Datele Beneficiarului", icon: "\u{1F464}", component: BeneficiarStep },
    { id: "servicii", label: "Servicii", title: "Obiectul si Durata Contractului", icon: "\u{1F4CB}", component: ServiciiStep },
    { id: "plata", label: "Plata", title: "Pretul si Modalitatea de Plata", icon: "\u{1F4B6}", component: PlataStep },
    { id: "clauze", label: "Clauze", title: "Clauze Contractuale", icon: "\u{1F4DD}", component: ClauzeStep },
    { id: "preview", label: "Preview", title: "Previzualizare Contract", icon: "\u{1F4C4}", component: PreviewStep },
  ],
  defaultData: {
    prestatorTip: "pf",
    prestatorNume: "",
    prestatorCNP: "",
    prestatorCI: "",
    prestatorAdresa: "",
    prestatorDenumire: "",
    prestatorCUI: "",
    prestatorRegCom: "",
    prestatorSediu: "",
    prestatorReprezentant: "",
    beneficiarTip: "pf",
    beneficiarNume: "",
    beneficiarCNP: "",
    beneficiarCI: "",
    beneficiarAdresa: "",
    beneficiarDenumire: "",
    beneficiarCUI: "",
    beneficiarRegCom: "",
    beneficiarSediu: "",
    beneficiarReprezentant: "",
    numarContract: "",
    obiectContract: "",
    durataNedeterminata: false,
    dataInceput: "",
    dataSfarsit: "",
    tipPret: "fix",
    pretSuma: "",
    pretMoneda: "RON",
    termenPlata: "finalizare",
    preavizReziliere: "30",
    includeNDA: true,
    includeNonCompete: false,
    transferPI: false,
    instantaCompetenta: "domiciliu_prestator",
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "prestator") {
      if (data.prestatorTip === "pf") {
        if (!data.prestatorNume.trim()) {
          errors.prestatorNume = "Numele este obligatoriu";
        } else if (data.prestatorNume.trim().split(/\s+/).length < 2) {
          errors.prestatorNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.prestatorCNP.trim() && !/^\d{13}$/.test(data.prestatorCNP.trim())) {
          errors.prestatorCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.prestatorCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.prestatorCI.trim())) {
          errors.prestatorCI = "Format invalid (ex: RD 123456)";
        }
        if (!data.prestatorAdresa.trim()) errors.prestatorAdresa = "Adresa este obligatorie";
      } else if (data.prestatorTip === "pfa") {
        if (!data.prestatorDenumire.trim()) errors.prestatorDenumire = "Denumirea PFA este obligatorie";
        if (!data.prestatorCUI.trim()) errors.prestatorCUI = "CUI-ul este obligatoriu";
        if (!data.prestatorSediu.trim()) errors.prestatorSediu = "Sediul este obligatoriu";
        if (!data.prestatorReprezentant.trim()) errors.prestatorReprezentant = "Reprezentantul este obligatoriu";
      } else {
        if (!data.prestatorDenumire.trim()) errors.prestatorDenumire = "Denumirea societatii este obligatorie";
        if (!data.prestatorCUI.trim()) {
          errors.prestatorCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.prestatorCUI.trim())) {
          errors.prestatorCUI = "Format invalid (ex: RO12345678)";
        }
        if (!data.prestatorSediu.trim()) errors.prestatorSediu = "Sediul social este obligatoriu";
        if (!data.prestatorReprezentant.trim()) errors.prestatorReprezentant = "Reprezentantul legal este obligatoriu";
      }
    }

    if (stepId === "beneficiar") {
      if (data.beneficiarTip === "pf") {
        if (!data.beneficiarNume.trim()) {
          errors.beneficiarNume = "Numele este obligatoriu";
        } else if (data.beneficiarNume.trim().split(/\s+/).length < 2) {
          errors.beneficiarNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.beneficiarCNP.trim() && !/^\d{13}$/.test(data.beneficiarCNP.trim())) {
          errors.beneficiarCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.beneficiarCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.beneficiarCI.trim())) {
          errors.beneficiarCI = "Format invalid (ex: MZ 654321)";
        }
        if (!data.beneficiarAdresa.trim()) errors.beneficiarAdresa = "Adresa este obligatorie";
      } else if (data.beneficiarTip === "pfa") {
        if (!data.beneficiarDenumire.trim()) errors.beneficiarDenumire = "Denumirea PFA este obligatorie";
        if (!data.beneficiarCUI.trim()) errors.beneficiarCUI = "CUI-ul este obligatoriu";
        if (!data.beneficiarSediu.trim()) errors.beneficiarSediu = "Sediul este obligatoriu";
        if (!data.beneficiarReprezentant.trim()) errors.beneficiarReprezentant = "Reprezentantul este obligatoriu";
      } else {
        if (!data.beneficiarDenumire.trim()) errors.beneficiarDenumire = "Denumirea societatii este obligatorie";
        if (!data.beneficiarCUI.trim()) {
          errors.beneficiarCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.beneficiarCUI.trim())) {
          errors.beneficiarCUI = "Format invalid (ex: RO12345678)";
        }
        if (!data.beneficiarSediu.trim()) errors.beneficiarSediu = "Sediul social este obligatoriu";
        if (!data.beneficiarReprezentant.trim()) errors.beneficiarReprezentant = "Reprezentantul legal este obligatoriu";
      }
    }

    if (stepId === "servicii") {
      if (!data.obiectContract.trim()) errors.obiectContract = "Descrierea serviciilor este obligatorie";
      if (!data.dataInceput) errors.dataInceput = "Data de inceput este obligatorie";
      if (!data.durataNedeterminata && !data.dataSfarsit) errors.dataSfarsit = "Data de sfarsit este obligatorie";
    }

    if (stepId === "plata") {
      if (!data.pretSuma || Number(data.pretSuma) <= 0) {
        errors.pretSuma = "Suma este obligatorie si trebuie sa fie pozitiva";
      }
    }

    return errors;
  },
};

export default prestariServiciiConfig;
